import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./editRewardCoupon.css";
    import { updateRewardCoupon, viewRewardCoupon } from "../../Redux/Actions/rewardCouponActions";
import { AgentList } from "../../Redux/Actions/agentActions";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";

const EditRewardCoupon = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { loading = false } = useSelector((state) => state.rewardCoupon || {});
  const { agents } = useSelector((state) => state.agents || {});
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    agent: "",
    code: "",
    no_of_usage: "",
    min_price: "",
    reward_point: "",
    start_date: "",
    end_date: "",
  });

  useEffect(() => {
    dispatch(AgentList({
      page: 1,
      limit: 1000,
      is_deleted: false,
      role: ["exclusive partner"],
    }));
  }, [dispatch]);

  useEffect(() => {
    if (!id) return;
    const fetchCoupon = async () => {
      try {
        const res = await dispatch(viewRewardCoupon(id));
        if (res?.data) {
          const d = res.data;
          setFormData({
            agent: d.agent?._id || d.agent || "",
            code: d.code || "",
            no_of_usage: d.no_of_usage || "",
            min_price: d.min_price || "",
            reward_point: d.reward_point || "",
            start_date: d.start_date ? new Date(d.start_date).toISOString().split("T")[0] : "",
            end_date: d.end_date ? new Date(d.end_date).toISOString().split("T")[0] : "",
          });
        }
      } catch {
        toast.error("Failed to load coupon details");
      }
    };
    fetchCoupon();
  }, [id, dispatch]);

  const clearError = (field) => {
    setErrors((prev) => { const n = { ...prev }; delete n[field]; return n; });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "code") {
      setFormData((prev) => ({ ...prev, code: value.toUpperCase() }));
      clearError("code");
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
    clearError(name);
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.agent) newErrors.agent = "Agent is required";
    if (!formData.code.trim()) newErrors.code = "Code is required";
    if (!formData.no_of_usage) newErrors.no_of_usage = "Number of usage is required";
    if (!formData.min_price) newErrors.min_price = "Minimum price is required";
    if (!formData.reward_point) newErrors.reward_point = "Reward point is required";
    if (!formData.start_date) newErrors.start_date = "Start date is required";
    if (!formData.end_date) newErrors.end_date = "End date is required";
    if (formData.start_date && formData.end_date && formData.end_date <= formData.start_date) {
      newErrors.end_date = "End date must be after start date";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      const payload = {
        agent: formData.agent,
        code: formData.code,
        no_of_usage: Number(formData.no_of_usage),
        min_price: Number(formData.min_price),
        reward_point: Number(formData.reward_point),
        start_date: formData.start_date,
        end_date: formData.end_date,
      };

      const response = await dispatch(updateRewardCoupon(id, payload));
      if (response?.statusCode === 200) {
        navigate("/dealsAndOffers");
      }
    } catch (error) {
      const msg = error?.response?.data?.message || error?.message || "Failed to update reward coupon";
      if (msg.toLowerCase().includes("duplicate") || msg.toLowerCase().includes("already")) {
        setErrors((prev) => ({ ...prev, code: "Coupon code already exists" }));
        return toast.error("Coupon code already exists");
      }
      toast.error(msg);
    }
  };

  return (
    <MainLayout>
      <div className="erc-wrapper">
        <div className="erc-header">
          <div className="erc-header-left">
            <div className="erc-header-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 12V22H4V12" /><path d="M22 7H2v5h20V7z" /><path d="M12 22V7" />
                <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" />
                <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
              </svg>
            </div>
            <div>
              <h1 className="erc-title">Edit Reward Coupon</h1>
              <p className="erc-subtitle">Update the details of this reward coupon</p>
            </div>
          </div>
          <Link to="/dealsAndOffers" className="erc-view-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 12V22H4V12" /><path d="M22 7H2v5h20V7z" />
            </svg>
            View Coupons
          </Link>
        </div>

        <form className="erc-form" onSubmit={handleSubmit}>
          <div className="erc-section erc-section--visible">
            <div className="erc-section-header">
              <span className="erc-section-badge">01</span>
              <h2 className="erc-section-title">Coupon Details</h2>
            </div>

            <div className="erc-grid erc-grid-2">

              <div className="erc-field erc-field--full">
                <label className="erc-label">Agent <span className="erc-req">*</span></label>
                <select
                  className={`erc-select ${errors.agent ? "erc-input--error" : ""}`}
                  name="agent"
                  value={formData.agent}
                  onChange={handleChange}
                  disabled={loading}
                >
                  <option value="">Select agent</option>
                  {Array.isArray(agents?.data) && agents.data.map((agent) => (
                    <option key={agent._id} value={agent._id}>
                      {agent.name} {agent.primary_contact_number ? `— ${agent.primary_contact_number}` : ""}
                    </option>
                  ))}
                </select>
                {errors.agent && <span className="erc-error-msg">{errors.agent}</span>}
              </div>

              <div className="erc-field erc-field--full">
                <label className="erc-label">Coupon Code <span className="erc-req">*</span></label>
                <input
                  className={`erc-input ${errors.code ? "erc-input--error" : ""}`}
                  type="text"
                  name="code"
                  value={formData.code}
                  onChange={handleChange}
                  placeholder="e.g. REWARD50"
                  disabled={loading}
                />
                {errors.code && <span className="erc-error-msg">{errors.code}</span>}
              </div>

              <div className="erc-field">
                <label className="erc-label">No of Usage <span className="erc-req">*</span></label>
                <input
                  className={`erc-input ${errors.no_of_usage ? "erc-input--error" : ""}`}
                  type="number"
                  name="no_of_usage"
                  value={formData.no_of_usage}
                  onWheel={(e) => e.target.blur()}
                  onChange={handleChange}
                  placeholder="e.g. 100"
                  disabled={loading}
                  min={1}
                />
                {errors.no_of_usage && <span className="erc-error-msg">{errors.no_of_usage}</span>}
              </div>

              <div className="erc-field">
                <label className="erc-label">Minimum Price <span className="erc-req">*</span></label>
                <input
                  className={`erc-input ${errors.min_price ? "erc-input--error" : ""}`}
                  type="number"
                  name="min_price"
                  value={formData.min_price}
                  onWheel={(e) => e.target.blur()}
                  onChange={handleChange}
                  placeholder="e.g. 500"
                  disabled={loading}
                  min={0}
                />
                {errors.min_price && <span className="erc-error-msg">{errors.min_price}</span>}
              </div>

              <div className="erc-field">
                <label className="erc-label">Reward Points <span className="erc-req">*</span></label>
                <input
                  className={`erc-input ${errors.reward_point ? "erc-input--error" : ""}`}
                  type="number"
                  name="reward_point"
                  value={formData.reward_point}
                  onWheel={(e) => e.target.blur()}
                  onChange={handleChange}
                  placeholder="e.g. 50"
                  disabled={loading}
                  min={0}
                />
                {errors.reward_point && <span className="erc-error-msg">{errors.reward_point}</span>}
              </div>

              <div className="erc-field">
                <label className="erc-label">Start Date <span className="erc-req">*</span></label>
                <input
                  className={`erc-input ${errors.start_date ? "erc-input--error" : ""}`}
                  type="date"
                  name="start_date"
                  value={formData.start_date}
                  onChange={handleChange}
                  disabled={loading}
                />
                {errors.start_date && <span className="erc-error-msg">{errors.start_date}</span>}
              </div>

              <div className="erc-field">
                <label className="erc-label">End Date <span className="erc-req">*</span></label>
                <input
                  className={`erc-input ${errors.end_date ? "erc-input--error" : ""}`}
                  type="date"
                  name="end_date"
                  value={formData.end_date}
                  onChange={handleChange}
                  disabled={loading}
                />
                {errors.end_date && <span className="erc-error-msg">{errors.end_date}</span>}
              </div>

            </div>
          </div>

          <div className="erc-footer">
            <div className="erc-footer-nav">
              <button type="submit" className="erc-btn erc-btn--submit" disabled={loading}>
                {loading ? "Saving..." : (
                  <>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    Update Coupon
                  </>
                )}
              </button>
            </div>
            <Link to="/dealsAndOffers" className="erc-btn erc-btn--cancel">Cancel</Link>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default EditRewardCoupon;